import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177ce896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-signup-profile l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "会員登録完了", -1))
const _hoisted_4 = { class: "ha__sec ha-signup-profile__sec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, "会員登録が完了しました。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, "このページは自動的にサービス画面に遷移します。", -1))
const _hoisted_7 = { class: "p-mypage__txt" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("※自動で遷移しない場合はお手数ですが、")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("をクリックしてください。")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkageSignupProgress = _resolveComponent("LinkageSignupProgress")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_LinkageSignupProgress, { signupProgress: "SignupComplete" }),
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("p", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("a", {
            class: "c-link--primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.callbackToken && _ctx.callbackToken(...args)))
          }, "こちら"),
          _hoisted_9
        ])
      ])
    ])
  ]))
}